import React, { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import Animated, { useAnimatedScrollHandler } from 'react-native-reanimated';
import StatusBar from 'design-system/StatusBar';
import { AppView, SCROLL_INDICATOR_INSETS, rem } from 'design-system';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { extractKeyFromKey } from 'utils/flatListHelpers';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import LearnVideoCard from './LearnVideoCard';
import { isWeb } from '../../../../constants';
const keyExtractor = extractKeyFromKey('name');
const EMPTY_VIDEOS = [];
const gap = { gap: 8 };
const LearnVideos = withAnimatedNavigationHeader(({ scrollY, navigation, route }) => {
    const { learnVideos } = route.params || EMPTY_VIDEOS;
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const containerStyles = useMarginBottom('paddingBottom', 0, styles.scrollView, paddingHorizontalStyle, styles.paddingSides);
    const scrollHandler = useAnimatedScrollHandler((handle) => {
        // eslint-disable-next-line no-param-reassign
        scrollY.value = handle.contentOffset.y;
    });
    const handlePress = useCallback((index) => () => {
        navigation.navigateDeprecated('InvestLearn', {
            videoIndex: index,
            learnVideos,
        });
    }, [learnVideos]);
    const renderItem = useCallback(({ item, index }) => (<LearnVideoCard grid key={index} title={item.name} thumbnail={item.thumbnail} onPress={handlePress(index)} lastItem={learnVideos.length % 2 !== 0 && index === learnVideos.length - 1}/>), [handlePress, learnVideos.length]);
    return (<AppView type="secondary" withFrame={false}>
        <StatusBar barStyle="dark-content" animated/>
        <Animated.FlatList numColumns={2} data={learnVideos} columnWrapperStyle={gap} renderItem={renderItem} scrollEventThrottle={16} onScroll={scrollHandler} keyExtractor={keyExtractor} contentContainerStyle={containerStyles} showsVerticalScrollIndicator scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}/>
      </AppView>);
}, ({ colors }) => ({
    title: 'Videos',
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
const styles = StyleSheet.create({
    scrollView: {
        paddingTop: rem(8),
    },
    paddingSides: {
        marginHorizontal: rem(16),
    },
});
export default LearnVideos;
